// Hand-written city page content, keyed by "<country-slug>/<city-slug>" (the page's folder under /guides/).
// To add one: copy lisbon.js, fill in what you have (every field is optional), import it here,
// and put its photos in public/city-pages/<city-slug>/. Cities without a file still get an automatic page
// once they have MIN_GUIDES_FOR_CITY_PAGE guides (see services/guidesSite.js).
import lisbon from './lisbon';
import porto from './porto';
import sintra from './sintra';
import madrid from './madrid';

export const CITY_CONTENT = {
  'portugal/lisbon': lisbon,
  'portugal/porto': porto,
  'portugal/sintra': sintra,
  'spain/madrid': madrid,
};
